import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import PropTypes from 'prop-types';
import Content from './Content';

const AvailableResources = ({ relationship }) => {
  const { initializingError, isInitializing } = usePageContentContext();
  return (
    <DataContainer
      component={Content}
      componentProps={{
        relationship,
      }}
      loading={isInitializing}
      loadingError={initializingError}
    />
  );
};

AvailableResources.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export default AvailableResources;
